import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Link as RouterLink } from "react-router-dom";
import type { PlatformBlockComponent } from "../../../types";
import { BlockFormHeader } from "../BlockFormHeader";

const COVERS_PATH = "/partner/platform/covers";

export const CustomCover: PlatformBlockComponent = () => {
  const { t } = useTranslation();

  return (
    <Paper sx={{ p: 2 }}>
      <BlockFormHeader blockType="CUSTOM_COVER" />
      <Stack spacing={2} alignItems="center">
        <Typography variant="subtitle1" textAlign="center">
          {t("platformBlocks.customCover.notice")}
        </Typography>
        <Button
          component={RouterLink}
          to={COVERS_PATH}
          variant="contained"
          color="primary"
        >
          {t("platformBlocks.customCover.openSection")}
        </Button>
      </Stack>
    </Paper>
  );
};
